(() => {
  const initialized = new WeakSet();

  function initReveal(root = document) {
    const nodes = root.querySelectorAll('[data-aura-reveal]');
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    nodes.forEach((node) => observer.observe(node));
  }

  function initAromaFilters(root = document) {
    root.querySelectorAll('[data-aura-aroma-browser]').forEach((browser) => {
      if (initialized.has(browser)) return;
      initialized.add(browser);

      const buttons = browser.querySelectorAll('[data-aura-filter]');
      const cards = browser.querySelectorAll('[data-aura-families]');
      const status = browser.querySelector('[data-aura-filter-status]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.auraFilter || 'all';
          buttons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));

          let visibleCount = 0;
          cards.forEach((card) => {
            const families = (card.dataset.auraFamilies || '').split(',').map((value) => value.trim());
            const visible = filter === 'all' || families.includes(filter);
            card.hidden = !visible;
            if (visible) visibleCount += 1;
          });

          if (status) status.textContent = `${visibleCount} aroma${visibleCount === 1 ? '' : 's'} visible${visibleCount === 1 ? '' : 's'}`;
        });
      });
    });
  }

  function init(root = document) {
    initReveal(root);
    initAromaFilters(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
